import * as yup from 'yup';

export default yup.object({
    email: yup.string().email().required(),
    password: yup.string().min(12).required(),
    password_confirm: yup.string().required()
        .test('passwords-match', 'Passwords must match', function(value){
            return this.parent.password === value
        })
})